import {
  botAcceptDeal,
  botBuyProperty,
  botChooseDeal,
  botPayBail,
  botRaiseCash,
  botUpgradeTarget,
} from './ai'
import {
  acceptDeal,
  buyProperty,
  canEndTurn,
  confirmPrompt,
  cur,
  declineDeal,
  declareBankrupt,
  endTurn,
  mortgageProperty,
  payBail,
  rollDice,
  sellAsset,
  sellProperty,
  skipBuy,
  upgradeProperty,
} from './engine'
import type { GameState } from './types'

/**
 * เดินหนึ่งก้าวแทนผู้เล่นคนปัจจุบัน
 * ใช้ทั้งกับบอทจริง ๆ และกับผู้เล่นออนไลน์ที่เน็ตหลุดจนต้องเล่นแทน
 * จึงไม่เช็ค isBot ในนี้ — ผู้เรียกเป็นคนตัดสินใจ
 */
export function botStep(g: GameState): void {
  if (g.phase === 'gameover') return
  const p = cur(g)

  if (g.prompt) {
    const prompt = g.prompt
    switch (prompt.t) {
      case 'buyProperty': {
        const decision = botBuyProperty(g, prompt.tileId)
        if (decision === 'skip') skipBuy(g)
        else buyProperty(g, decision)
        return
      }
      case 'deal': {
        const choices = prompt.choices ?? [prompt.card]
        const chosen = botChooseDeal(choices)
        if (botAcceptDeal(g, chosen)) acceptDeal(g, chosen.id)
        else declineDeal(g)
        return
      }
      case 'bankruptWarning': {
        const action = botRaiseCash(g)
        if (!action) {
          declareBankrupt(g, p)
          return
        }
        if (action.t === 'sellAsset') sellAsset(g, action.uid)
        else if (action.t === 'mortgage') mortgageProperty(g, action.tileId)
        else sellProperty(g, action.tileId)
        if (p.cash >= 0) confirmPrompt(g)
        return
      }
      default:
        confirmPrompt(g)
        return
    }
  }

  if (p.quarantine > 0) {
    if (botPayBail(g)) payBail(g)
    else endTurn(g)
    return
  }

  if (g.phase === 'idle') {
    rollDice(g)
    return
  }

  if (g.phase === 'action') {
    const target = botUpgradeTarget(g)
    if (target !== null) {
      upgradeProperty(g, target)
      return
    }
    if (canEndTurn(g)) endTurn(g)
  }
}
